import {
    MANUAL_STRATEGY_TYPE,
    MAX_CHARACTERS_FOR_BID_STRATEGY_NAME,
    TARGET_IMPRESSION_SHARE,
    TARGET_STRATEGY_TYPE,
    UNKNOWN_BID_STRATEGY,
} from '@domain/budget-manager/modal/budget-manager-campaigns-modal.constants';
import { PLATFORMS } from '@domain/platform';
import { convertAllCapsSnakeCaseToTitleCase, limitNumberOfCharacters } from '@shared/utils/strings';
import { Campaign } from './campaigns-info.types';

export const getExtraFieldsForCampaignsInfo = campaign => ({
    bid_strategy_type: getFormattedBidStrategy(campaign),
});

const getFormattedBidStrategy = (campaign: Campaign) => {
    const isFacebookAdsCampaign = isFacebookAds(campaign);
    const isTargetImpressionShare = campaign.bid_strategy_type === UNKNOWN_BID_STRATEGY;

    if (isTargetImpressionShare) {
        return TARGET_IMPRESSION_SHARE;
    }

    return (
        limitNumberOfCharacters(
            getStrategyForCampaign(campaign, isFacebookAdsCampaign),
            MAX_CHARACTERS_FOR_BID_STRATEGY_NAME,
        )
    );
};

const getStrategyForCampaign = (campaign: Campaign, isFacebook: boolean) => (
    isFacebook
        ? convertAllCapsSnakeCaseToTitleCase(campaign.bid_strategy_type)
        : formatStrategyTypeForGoogle(campaign)
);

const formatStrategyTypeForGoogle = (
    campaign: Campaign,
) => MANUAL_STRATEGY_TYPE[campaign.bid_strategy_type]
    || TARGET_STRATEGY_TYPE[campaign.bid_strategy_type]
    || convertAllCapsSnakeCaseToTitleCase(campaign.bid_strategy_type);

const isFacebookAds = (campaign: Campaign) => campaign.platform === PLATFORMS.FACEBOOK_ADS.value;
